module.exports = __webpack_public_path__ + "static/media/logo.d1f80fb7.png";